export default class Country {
  id: string;

  name: string;

  acronym: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.acronym = obj.acronym || '';
  }
}
